import * as routeHelpers from "../../lib/routeHelpers";
import OutlineButton from "../OutlineButton";
import PaymentsMethodHeader from "../PaymentMethodsHeader";
import React from "react";
import styles from "./OtherPaymentMethods.module.css";
import {useNavigate} from "react-router-dom";
import {useAppSelector} from "../../lib/hooks";

const strings = {
    otherPaymentMethods: "Other Payment Options",
    fundraiser: "Fundraiser",
    ezCaterPickup: "EzCater Pickup",
    ezCaterDelivery: "EzCater Delivery",
};

export function OtherPaymentMethods() {
    const navigate = useNavigate();
    const supportedExternalTenders = useAppSelector(
        (state) => state.pos.supportedExternalTenders,
    );

    return (
        <div>
            <PaymentsMethodHeader
                backPromptLabel={strings.otherPaymentMethods}
                to={routeHelpers.payment()}
            />
            <div className={styles.paymentMethodOptionsContainer}>
                <OutlineButton
                    className={styles.paymentMethodOptionButton}
                    label={strings.fundraiser}
                    onClick={() => {
                        navigate(routeHelpers.fundraiser());
                    }}
                />
                <OutlineButton
                    className={styles.paymentMethodOptionButton}
                    label={strings.ezCaterPickup}
                    onClick={() => {
                        navigate(routeHelpers.ezCater(true));
                    }}
                />
                <OutlineButton
                    className={styles.paymentMethodOptionButton}
                    label={strings.ezCaterDelivery}
                    onClick={() => {
                        navigate(routeHelpers.ezCater(false));
                    }}
                />
                {supportedExternalTenders.map((tenderName, i) => {
                    return (
                        <OutlineButton
                            key={i}
                            className={styles.paymentMethodOptionButton}
                            label={tenderName}
                            onClick={() => {
                                navigate(
                                    routeHelpers.externalTender(tenderName),
                                );
                            }}
                        />
                    );
                })}
            </div>
        </div>
    );
}
